export default __webpack_public_path__ + "static/media/icono_vespertino.31a54198.svg";